module.exports = __webpack_public_path__ + "static/media/NewThisMonth.45dbb8dc.png";